import { render, staticRenderFns } from "./other-property-existing-mortgage.vue?vue&type=template&id=4a65c74b"
import script from "./other-property-existing-mortgage.vue?vue&type=script&lang=ts"
export * from "./other-property-existing-mortgage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports